import { render, staticRenderFns } from "./VersionReceive.vue?vue&type=template&id=2cbe681c&scoped=true"
import script from "./VersionReceive.vue?vue&type=script&lang=js"
export * from "./VersionReceive.vue?vue&type=script&lang=js"
import style0 from "./VersionReceive.vue?vue&type=style&index=0&id=2cbe681c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cbe681c",
  null
  
)

export default component.exports